import React from 'react';
import { Icon } from '@iconify/react';
import squareFill from '@iconify/icons-eva/square-fill';
import minusSquareFill from '@iconify/icons-eva/minus-square-fill';
import checkmarkSquare2Fill from '@iconify/icons-eva/checkmark-square-2-fill';
// ----------------------------------------------------------------------
const ICON_MEDIUM = { width: 24, height: 24 };
const ICON_SMALL = { width: 20, height: 20 };
export const Checkbox = ({ theme }) => {
    return {
        MuiCheckbox: {
            defaultProps: {
                color: 'primary',
                icon: React.createElement(Icon, Object.assign({ icon: squareFill }, ICON_MEDIUM)),
                checkedIcon: React.createElement(Icon, Object.assign({ icon: checkmarkSquare2Fill }, ICON_MEDIUM)),
                indeterminateIcon: React.createElement(Icon, Object.assign({ icon: minusSquareFill }, ICON_MEDIUM))
            },
            styleOverrides: {
                root: {
                    padding: 8,
                    '& svg[font-size="small"]': Object.assign({}, ICON_SMALL),
                    '&$disabled': {
                        color: `${theme.palette.action.disabled} !important`
                    }
                }
            }
        }
    };
};
//# sourceMappingURL=Checkbox.js.map